<div class="page-container">
    <h2 class="page-title">COUNSELLOR PERFORMANCE</h2>

    <!-- ======== FILTER ROW ======== -->
    <div class="filter-row">

        <!-- COUNSELLOR MULTI SELECT -->
        <mat-form-field appearance="outline">
            <mat-label>Counsellors</mat-label>

            <mat-select multiple [(ngModel)]="selectedCounsellors">

                <mat-option (click)="toggleSelectAll()" [value]="'all'">
                    <input type="checkbox" class="custom-checkbox" [checked]="isAllSelected" tabindex="-1" />
                    <span class="option-label">Select All</span>
                </mat-option>

                <mat-option *ngFor="let c of counsellors" [value]="c.refNo">
                    <input type="checkbox" class="custom-checkbox" [checked]="selectedCounsellors.includes(c.refNo)" tabindex="-1" />
                    <span class="option-label">{{ c.userName }}</span>
                </mat-option>

            </mat-select>
        </mat-form-field>

        <!-- DATE FROM -->
        <mat-form-field appearance="outline">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDate">
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>

        <!-- DATE TO -->
        <mat-form-field appearance="outline">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="picker2" [(ngModel)]="toDate">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>

        <!-- APPLY BUTTON -->
        <button mat-raised-button color="primary" (click)="applyFilter()">
            <mat-spinner *ngIf="loading" diameter="18" strokeWidth="2" style="margin-right: 5px"></mat-spinner>
            <span *ngIf="!loading">Apply</span>
        </button>
    </div>

    <!-- ======== TABLE ======== -->
    <div class="table-container" style="margin-top: 8px; overflow-y: auto; height: 300px;">
        <table class="table table-sm table-hover" style="padding-right: 20px;">
            <tr style="background-color: blue;color: white; position: sticky; top: 0;">
                <th *ngFor="let column of displayedColumns">{{ column }}</th>
            </tr>
            <tbody>
                <tr *ngFor="let element of tableData; let i = index;" style="vertical-align: top;">
                    <td *ngFor="let column of displayedColumns">{{ element[column] }}</td>
                </tr>
                <tr *ngIf="!tableData || tableData.length === 0">
                    <th [attr.colspan]="displayedColumns.length" style="text-align: center; padding: 20px;">No data found!</th>
                </tr>
            </tbody>
        </table>
    </div>

    <!-- ======== PAGINATION ======== -->
    <div class="pagination-wrapper" *ngIf="totalRecords > 0">
        <ul class="pagination">
            <li [class.disabled]="currentPage === 1">
                <a (click)="onPageChange({ pageIndex: 0 })" class="page-link">First</a>
            </li>
            <li [class.disabled]="currentPage === 1">
                <a (click)="onPageChange({ pageIndex: currentPage - 2 })" class="page-link">Prev</a>
            </li>
            <li *ngFor="let page of getPaginationPages()" [class.active]="currentPage === page">
                <a (click)="onPageChange({ pageIndex: page - 1 })" class="page-link">{{ page }}</a>
            </li>
            <li [class.disabled]="currentPage === totalPages">
                <a (click)="onPageChange({ pageIndex: currentPage })" class="page-link">Next</a>
            </li>
            <li [class.disabled]="currentPage === totalPages">
                <a (click)="onPageChange({ pageIndex: totalPages - 1 })" class="page-link">Last</a>
            </li>
        </ul>
    </div>
</div>